import { createApp } from 'vue';
import { initSentry } from '@utils';
import Cloudinarize from '@plugins/cloudinarize';
import initializeGoogleMaps from '@services/google_maps_initializer';
import PublicDirectory from '../src/static/components/public-directory.vue';

initSentry();
initializeGoogleMaps();

const app = {
  components: {
    PublicDirectory,
  },
};

createApp(app)
  .use(Cloudinarize)
  .mount('#public_directory_vue');
